import {combineReducers} from "redux";
// 默认值
import {userInfo, quantileTimeList} from './state.js';
const setUserInfo = (state = userInfo, action) => {
    switch(action.type) {
        case "login":
            return Object.assign(state, action.data);
        default:
            return state
    }
};
const setQuantileTimeList = (state = quantileTimeList, action) => {
    switch(action.type) {
        case "quantileTimeList":
            return Object.assign(state, action.data);
        default:
            return state
    }
};

// 导出所有reducer
export default combineReducers({
    setUserInfo,
    setQuantileTimeList
})
